<section class="bleed-surface-100 bleed-bg pt-12">
  @if (signupState() === 'not-signed-up' && footerStyle() === 'with-email-list') {
    <h2 class="text-3xl font-medium mb-6">
      {{ 'footer.emailList.title' | transloco }}
    </h2>

    <p>{{ 'footer.emailList.subtitle' | transloco }}</p>

    <p class="text-xs text-muted-color mt-4">
      {{ 'footer.emailList.consentPrefix' | transloco }}
      <a class="underline cursor-pointer" routerLink="/privacy-policy">
        {{ 'common.nav.privacy' | transloco }}
      </a>.
    </p>

    <input
      pInputText
      class="w-full mt-6"
      [placeholder]="'common.placeholder.email' | transloco"
      [(ngModel)]="email"
    />

    <p-button
      (onClick)="onEmailSubmit()"
      class="block mt-2"
      severity="secondary"
      [label]="'common.cta.subscribe' | transloco"
    ></p-button>

    <div class="py-6">
      <p-divider/>
    </div>
  }

  <h2 class="text-3xl font-medium mb-6">
    <ng-content>
      {{ 'footer.hero.line1' | transloco }}<br />
      <span class="text-orange-gradient">
        {{ 'footer.hero.line2' | transloco }}
      </span>
    </ng-content>
  </h2>

  <ul class="flex flex-col gap-6 mb-10">
    <li>
      <app-try-reason [text]="'footer.reasons.createProfile' | transloco"/>
    </li>
    <li>
      <app-try-reason [text]="'footer.reasons.autoEnter' | transloco"/>
    </li>
    <li>
      <app-try-reason [text]="'footer.reasons.winNotifications' | transloco"/>
    </li>
  </ul>

  <div class="flex flex-row justify-center mb-12">
    <homey-signup-button [wide]="true" [defaultSignupRoute]="defaultSignupRoute()"/>
  </div>

  <p-divider></p-divider>
</section>

<footer homeyFooter [includeTopPadding]="false" [showLogin]="showLogin()"></footer>
